import * as React from 'react';

import { Form } from '@longline/aqua-ui/containers/Form';
import { CountryDropdown } from '@longline/aqua-ui/modules/CountryDropdown';
import { Input } from '@longline/aqua-ui/inputs/Input';

import { IProfile } from '../../api/models/IProfile';

interface IProps {
  data: IProfile;
  onChange: (profile: IProfile, forceUpdate: boolean) => void;
  onValidate: (valid: boolean) => void;
}

const ProfileForm = (props: IProps) => {
  return (
    <Form
      data={props.data}
      onChange={props.onChange}
      onValidate={props.onValidate}
    >
      <Form.Field
        rules={{
          required: { message: "Name is required." }
        }}
        name="name"
        value={props.data.name}
        label="Name"
        wrapper='box'
        control={(
          <Input
            transparent
            type="text"
            placeholder="Your name"
            fluid
          />
        )}
        hint={<>Your <b>name</b>.</>}
      />

      <Form.Field
        rules={{
        }}
        name="country"
        value={props.data.country}
        label="Country"
        wrapper='box'
        control={(
          <CountryDropdown fluid placeholder="Your home country"/>
        )}
        hint={<>Your <b>home country</b>.</>}
      />

      <Form.Field
        rules={{
          pattern: { pattern: "^\\+[1-9]\\d{6,14}$", message: "Must be in international format, e.g. +447700900123." }
        }}
        name="phoneNumber"
        value={props.data.phoneNumber}
        label="Phone number"
        wrapper='box'
        control={(
          <Input
            transparent
            type="text"
            placeholder="+447700900123"
            fluid
          />
        )}
        hint={<>International format. Required for SMS login.</>}
      />

    </Form>
  ) 
}

export { ProfileForm }
